import { underscore } from 'inflected';

export class TextUtility {

    public static toCamelCase(text: string): string {
        const camel = text
            .replace(/\s(.)/g, function ($1) { return $1.toUpperCase(); })
            .replace(/\s/g, '')
            .replace(/^(.)/, function ($1) { return $1.toLowerCase(); })
            .replace(/\//g, '');

        return camel;
    }

    // Prevent character that can cause issues in the form engine
    // - & cause issue when rendering form PDF using LinQ Report Engine
    public static excludeSpecialCharacters(text: string): string {
        const safeText = text.replace('&', '');
        return safeText;
    }

    public static toUnderscoreCase(text: string): string {
        const camel = this.toCamelCase(text);
        return underscore(camel);
    }

    //Takes any special regex character and adds a backslash before it.
    //Prevents regex injection and errors when users attempt to use special regex characters like slashes
    public static toSafeRegexFilter(text: string): string {
        const safeFilter = text.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        return safeFilter;
    }

    // Trim if string; other types pass through. Keeps '' (no null coercion).
    public static trim<T>(value: T): T {
        return typeof value === 'string' ? (value.trim() as unknown as T) : value;
    }

    // Like trim, but an empty result becomes null.
    public static trimToNull<T>(value: T): T {
        return typeof value === 'string' ? ((value.trim() || null) as unknown as T) : value;
    }
}